import { useMemo } from "react";

import { OrderDetails } from "../../../../stores/slices/cartSlice";
import { useOrdersDateParam } from "./OrdersDateSelect";
import { getMinimumDate } from "./getMinimumDate";

interface OrderDatePredicateHook {
  (): (item: OrderDetails) => boolean;
}

export const useOrdersDatePredicate: OrderDatePredicateHook = () => {
  const [param] = useOrdersDateParam();
  const predicate = useMemo(
    () => (item: OrderDetails) => {
      const minDate = getMinimumDate(param);
      return new Date(item.orderCreatedTimestamp) >= minDate;
    },
    [param]
  );
  return predicate;
};
